<script setup lang="ts">
import { computed, type PropType } from 'vue'
import type { MaterialIcon, IconSize } from '@/types/components.interfaces'

const props = defineProps({
  name: {
    type: String as PropType<MaterialIcon>,
    required: true,
  },
  size: {
    type: String as PropType<IconSize>,
    default: 'md',
  },
  dataTest: {
    type: String,
    required: false,
    default: '',
  },
})

const fontSize = computed<number>(() => {
  switch (props.size) {
    case 'xs':
      return 14
    case 's':
      return 16
    case 'sm':
      return 18
    case 'lg':
      return 36
    case 'xl':
      return 48
    case 'md':
    default:
      return 24
  }
})
</script>

<template>
  <PuikIcon
    class="font-normal"
    :icon="name"
    :font-size="fontSize"
    :data-test="dataTest"
  />
</template>
